export default __webpack_public_path__ + "static/media/press_room_thumb14.1de5dd56.png";